import { irwin } from 'config'
import { httpClient } from './httpClient'
import Jsona, { SwitchCaseJsonMapper } from 'jsona'
import { toCamel, toSnake } from 'change-object-case'

const deserializer = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper({ switchChar: '_' }),
})

function client() {
  return httpClient(irwin.baseUrl)
}

async function getCustomers(params = {}) {
  // Request the email inbound address so the edit modal opened from the list can
  // populate the Irwin mail subdomain. The index omits it by default to stay lean.
  const response = await client().get('v2/customers', {
    params: { ...toSnake(params), include: 'email_inbound_address' },
  })

  return {
    data: deserializer.deserialize(response),
    meta: toCamel(response.meta),
    links: response.links,
  }
}

async function getCustomer(id) {
  const response = await client().get(`v2/customers/${id}`)

  return {
    data: deserializer.deserialize(response),
    meta: toCamel(response.meta),
    links: response.links,
  }
}

async function saveCustomer(customer) {
  const savedCustomer = customer.id
    ? await updateCustomer(customer)
    : await createCustomer(customer)

  return savedCustomer
}

async function createCustomer(customer) {
  const response = await client().post(
    'v2/customers',
    toSnake(customer, { recursive: true, arrayRecursive: true }),
  )
  return deserializer.deserialize(response)
}

async function updateCustomer(customer) {
  const response = await client().put(
    `v2/customers/${customer.id}`,
    toSnake(customer, { recursive: true, arrayRecursive: true }),
  )
  return deserializer.deserialize(response)
}

async function archiveCustomer(customer) {
  const response = await client().post(`v2/customers/${customer.id}/archive`)

  return deserializer.deserialize(response)
}

async function unarchiveCustomer(customer) {
  const response = await client().post(`v2/customers/${customer.id}/unarchive`)

  return deserializer.deserialize(response)
}

async function fetchOrCreateAuthorization(customerId) {
  return await client().put(`v2/customers/${customerId}/authorization`)
}

async function fetchCustomerAccountManagers(customerId, params) {
  const response = await client().get(`v2/customers/${customerId}/account_manager`, {
    params: toSnake(params),
  })
  return deserializer.deserialize(response)
}

async function upsertCustomerAccountManagers(customerId, params) {
  const response = await client().post(
    `v2/customers/${customerId}/account_manager`,
    toSnake(params),
  )

  return deserializer.deserialize(response)
}

export {
  getCustomers,
  getCustomer,
  saveCustomer,
  archiveCustomer,
  unarchiveCustomer,
  updateCustomer,
  fetchOrCreateAuthorization,
  fetchCustomerAccountManagers,
  upsertCustomerAccountManagers,
}
